import axiosInstanceNode from "@/api/axiosInstanceNode";

/** Fetch users list (filtered by role on backend: superadmin = all, org_admin = their org) */
export const fetchUsersList = async (params = {}) => {
  try {
    const { limit = 50, offset = 0 } = params;
    const response = await axiosInstanceNode.get("/auth/users", {
      params: { limit, offset },
    });
    return response?.data?.users;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch users list. Please try again."
    );
  }
};

/** Approve or reject trial/access request (action: "approve" | "reject") */
export const reviewTrialRequest = async (userId, action) => {
  try {
    const response = await axiosInstanceNode.post(
      `/auth/users/${userId}/approve-trial`,
      { action }
    );
    return response.data;
  } catch (error) {
    const msg =
      action === "approve"
        ? "Failed to approve request. Please try again."
        : "Failed to reject request. Please try again.";
    throw new Error(
      error.response?.data?.error || error.response?.data?.message || msg
    );
  }
};
